module.exports = __webpack_public_path__ + "static/media/chinese_03.b710badd.jpg";